import React from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { last } from 'lodash'
import Grid from '@material-ui/core/Grid'
import Cards from 'components/TemplateForm/Cards'
import Templates from 'components/Templates'
import Themes from 'components/TemplateForm/ThemesList'
import Select from 'components/AddOrEditTaskPage/Select'
import TemplateName from 'components/TemplateForm/TemplateName'
import Subject from 'components/TemplateForm/Subject'
// import { receiveTemplate, selectEmailCard } from 'actions/template'
import language from 'utils/vast-languagepack'
// import { stepperIncrease } from 'actions/view'

const inputProps = { style: { padding: '8.5px 14px' } }

export default connect(
  (state) => ({
    emailCardSelected: last(state.email.cardSelected),
  }),
  null,
  // (dispatch) =>
  //   bindActionCreators(
  //     { receiveTemplate, selectEmailCard, stepperIncrease },
  //     dispatch,
  //   ),
)(({ emailCardSelected /* , receiveTemplate, selectEmailCard */ }) => {
  switch (emailCardSelected) {
    case 'blank':
      return (
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <Select />
          </Grid>
          <Grid item xs={12}>
            <TemplateName
              inputProps={inputProps}
              helperText={language.task.add.helperText.templateName}
            />
          </Grid>
          <Grid item xs={12}>
            <Subject
              inputProps={inputProps}
              helperText={language.task.add.helperText.subject}
            />
          </Grid>
        </Grid>
      )
    case 'templates':
      return (
        <Templates
          // handleTemplateClick={(template) => {
          //   receiveTemplate(template)
          //   selectEmailCard('blank')
          //   stepperIncrease('task')
          // }}
          cols={2}
          taskForm
        />
      )
    case 'themes':
      return <Themes taskForm cols={2} />
    default:
      return <Cards cols={3} taskForm />
  }
})
